export default __webpack_public_path__ + "static/media/prototype1.f5f5ff6b.png";